import {
    activateTooltips,
    getBaseUrl,
    // NOPE: localization,
} from "../../common";

import {
    EditionsViewer,
} from '../../lib-custom';

import {
    // plugins.reader
    BookPage,
    ContentItem,
    PageDescription,
    SearchHitResult,
} from "../../plugins";

import { Device } from "./readerHeader";
import { ReaderLayout } from "./readerLayout";

// Use this to debug page joining.
// TODO: add the folios here when a page is explicitly requested
//       with a click in pagination
var debugEnableFolios = [
    /*
    'Leave empty (comment out the contents) to disable debugging.',
    'Or add folio names at runtime through the browser console and then scroll.',
    */
];
var debugFoliosWarned = {};

abstract class Panel {
    identificator: string;
    innerContent: HTMLElement;
    sc: ServerCommunication;

    parentReader: ReaderLayout;
    /**
     * maybe a better, more explicit name for the more generic (and thus less
     * useful, less expressive, I’d say) `parentReader`?
     */
    protected readerLayout: ReaderLayout;

    protected readonly errorHandler: ErrorHandler;

    constructor(
        identificator: string,
        readerLayout: ReaderLayout,
        sc: ServerCommunication,
        createBodyEarly: boolean = true,
    ) {
        this.identificator = identificator;
        this.sc = sc;
        this.parentReader = readerLayout;
        this.readerLayout = readerLayout;
        this.errorHandler = new ErrorHandler();

        if (createBodyEarly) {
            this.createBody();
        }
    }

    public createBody()
    {
        this.innerContent = this.makeBody(this, window);
    }

    protected makeBody(rootReference: Panel, window: Window): HTMLElement {
        throw new Error("Not implemented");
    }

    public getPanelHtml(): HTMLDivElement {
        var panelDiv: HTMLDivElement = document.createElement("div");
        panelDiv.id = this.identificator;
        this.addPanelClass(panelDiv);
        panelDiv.appendChild(this.innerContent);
        return panelDiv;
    }

    public onMoveToPage(pageIndex: number, scrollTo: boolean) {

    }

    protected addPanelClass(sidePanelDiv: HTMLDivElement) {
        throw new Error("Not implemented");
    }
}

abstract class ToolPanel extends Panel {
    addPanelClass(sidePanelDiv: HTMLDivElement): void {
        $(sidePanelDiv).addClass("reader-tool-panel");
    }
}

class ContentPanel extends ToolPanel {
    makeBody(rootReference: Panel, window: Window): HTMLElement {
        var bodyDiv: HTMLDivElement = window.document.createElement("div");
        $(bodyDiv).addClass("content-panel-container");
        this.innerContent = bodyDiv;
        this.downloadBookContent();
        return bodyDiv;
    }

    private downloadBookContent() {

        $(this.innerContent).empty();
        var loading = lv.create(null, "lv-dots lv-mid md");
        $(this.innerContent).append(loading.getElement());
        var bookContent: JQueryXHR = this.sc.getBookContent(this.parentReader.bookId);
        bookContent.done((response: { content: IChapterHieararchyContract[] }) => {
            var ulElement = document.createElement("ul");
            $(ulElement).addClass("content-item-root-list");

            if (response.content.length > 0) {
                for (var i = 0; i < response.content.length; i++) {
                    var chapterItem: IChapterHieararchyContract = response.content[i];
                    $(ulElement).append(this.makeContentItem(this.parseJsonItemToContentItem(chapterItem)));
                }

                $(this.innerContent).empty();
                $(this.innerContent).append(ulElement);
            } else {
                var alert = new AlertComponentBuilder(AlertType.Info);
                alert.addContent(localization.translate("no-content", "BookReader").value);
                $(this.innerContent).html(alert.buildElement());

            }

        });
        bookContent.fail(() => {
            $(this.innerContent).empty();
            $(this.innerContent).append(localization.translate("LoadingContentError", "BookReader").value);
        });
    }

    private parseJsonItemToContentItem(chapterItem: IChapterHieararchyContract): ContentItem {
        // TODO: replace pagesById with pagesByXmlIds
        var pageItem = chapterItem.beginningPageId != null
            ? this.parentReader.pagesById[chapterItem.beginningPageId]
            : null;
        var pageItemText = pageItem != null ? pageItem.text : "";
        return new ContentItem(chapterItem.name, chapterItem.beginningPageId,
            pageItemText, chapterItem.subChapters);
    }

    private makeContentItemChilds(contentItem: ContentItem): HTMLUListElement {
        var childItems: IChapterHieararchyContract[] = contentItem.childBookContentItems;
        if (childItems.length === 0) return null;
        var ulElement = document.createElement("ul");
        $(ulElement).addClass("content-item-list");
        for (var i = 0; i < childItems.length; i++) {
            var jsonItem: IChapterHieararchyContract = childItems[i];
            $(ulElement).append(this.makeContentItem(this.parseJsonItemToContentItem(jsonItem)));
        }
        return ulElement;
    }

    private makeContentItem(contentItem: ContentItem): HTMLLIElement {
        var liElement = document.createElement("li");
        $(liElement).addClass("content-item");

        var hrefElement = document.createElement("a");
        hrefElement.href = "#";
        $(hrefElement).click(() => {
            if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                $($(".view-control button")[1] as Node as HTMLElement).click();
            }
            this.parentReader.readerLayout.eventHub.emit("navigationClicked", contentItem.referredPageId);
        });
        this.parentReader.readerLayout.on("itemCreated", () => {
            $(hrefElement).click(() => {
                if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                    $($(".view-control button")[1] as Node as HTMLElement).click();
                }
                this.parentReader.readerLayout.eventHub.emit("navigationClicked", contentItem.referredPageId);
            });
        });

        var textSpanElement = document.createElement("span");
        $(textSpanElement).addClass("content-item-text");
        $(textSpanElement).text(contentItem.text);

        var pageNameSpanElement = document.createElement("span");
        $(pageNameSpanElement).addClass("content-item-page-name");
        if (contentItem.referredPageName !== "") {
            $(pageNameSpanElement).text("[" + contentItem.referredPageName + "]");
        }
        $(hrefElement).append(pageNameSpanElement);
        $(hrefElement).append(textSpanElement);

        $(liElement).append(hrefElement);
        $(liElement).append(this.makeContentItemChilds(contentItem));
        return liElement;
    }
}

class SearchResultPanel extends ToolPanel {
    private searchResultItemsDiv: HTMLDivElement;
    private searchPagingDiv: HTMLDivElement;

    private itemsCount: number;
    private paginator: Pagination;
    private paginatorOptions: Pagination.Options;
    private resultsOnPage;
    private maxPaginatorVisibleElements;

    public getSearchResultDiv(): HTMLDivElement {
        return this.searchResultItemsDiv;
    }

    public getPaginator(): Pagination {
        return this.paginator;
    }

    public replaceSearchPanelContent() {
        var newContent = this.makeBody(this, window);
        var $innerContent = $(this.innerContent);
        var contentParent = $innerContent.parent();

        $innerContent.remove();
        contentParent.append(newContent);
        this.innerContent = newContent;


    }

    protected makeBody(rootReference: Panel, window: Window): HTMLElement {
        var innerContent: HTMLDivElement = window.document.createElement("div");

        var searchResultItemsDiv = window.document.createElement("div");
        $(searchResultItemsDiv).addClass("reader-search-result-items-div");
        this.searchResultItemsDiv = searchResultItemsDiv;

        var pagingDiv = window.document.createElement("div");
        $(pagingDiv).addClass("reader-search-result-paging pagination-extra-small");
        this.searchPagingDiv = pagingDiv;
        if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
            this.resultsOnPage = MAX_INTEGER;
        } else {
            this.resultsOnPage = 8;
        }
        this.maxPaginatorVisibleElements = 11;

        this.paginatorOptions = {
            container: this.searchPagingDiv,
            maxVisibleElements: this.maxPaginatorVisibleElements,
            callPageClickCallbackOnInit: true
        };
        this.paginator = new Pagination(this.paginatorOptions);


        innerContent.appendChild(this.searchPagingDiv);
        innerContent.appendChild(searchResultItemsDiv);

        return innerContent;
    }

    createPagination(pageChangedCallback: (pageNumber: number) => void, itemsCount: number, currentPage: number) {
        if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
            currentPage = 1;
        }
        this.paginatorOptions.pageClickCallback = pageChangedCallback;
        this.itemsCount = itemsCount;
        this.paginator.make(itemsCount, this.resultsOnPage, currentPage);
    }

    getResultsCountOnPage(): number {
        return this.resultsOnPage;
    }

    showResults(searchResults: SearchHitResult[]) {
        this.clearResults();
        if(searchResults.length) {
            for (var i = 0; i < searchResults.length; i++) {
                var result = searchResults[i];
                var resultItem = this.createResultItem(result);
                this.searchResultItemsDiv.appendChild(resultItem);
            }
        }
        else {
            var noResultItemDiv = document.createElement("div");
            $(noResultItemDiv).addClass("no-results");
            $(noResultItemDiv).text(localization.translate("NoResults", "BookReader").value);
            this.searchResultItemsDiv.appendChild(noResultItemDiv);
        }
    }

    showErrorResults(error: JQueryXHR) {
        this.clearResults();
        const alert = new AlertComponentBuilder(AlertType.Error).addContent(this.errorHandler.getErrorMessage(error));
        this.searchResultItemsDiv.appendChild(alert.buildElement());
    }

    private createResultItem(result: SearchHitResult): HTMLDivElement {
        var resultItemDiv = document.createElement("div");
        $(resultItemDiv).addClass("reader-search-result-item");
        $(resultItemDiv).click(() => {
            if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                $($(".view-control button")[1] as Node as HTMLElement).click();
            }
            var pageId = Number(result.pageId);
            this.parentReader.readerLayout.eventHub.emit("navigationClicked", pageId);
        });
        this.parentReader.readerLayout.on("itemCreated", () => {
            $(resultItemDiv).click(() => {
                if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                    $($(".view-control button")[1] as Node as HTMLElement).click();
                }
                var pageId = Number(result.pageId);
                this.parentReader.readerLayout.eventHub.emit("navigationClicked", pageId);
            });
        });

        var pageNameSpan = document.createElement("span");
        $(pageNameSpan).addClass("reader-search-result-name");
        $(pageNameSpan).text(result.pageName);

        var resultBeforeSpan = document.createElement("span");
        $(resultBeforeSpan).addClass("reader-search-result-before");
        $(resultBeforeSpan).text(result.before);

        var resultMatchSpan = document.createElement("span");
        $(resultMatchSpan).addClass("reader-search-result-match");
        $(resultMatchSpan).text(result.match);

        var resultAfterSpan = document.createElement("span");
        $(resultAfterSpan).addClass("reader-search-result-after");
        $(resultAfterSpan).text(result.after);

        resultItemDiv.appendChild(pageNameSpan);
        resultItemDiv.appendChild(resultBeforeSpan);
        resultItemDiv.appendChild(resultMatchSpan);
        resultItemDiv.appendChild(resultAfterSpan);

        return resultItemDiv;
    }

    showLoading() {
        var loader = lv.create(null, "loading-animation lv-dots lv-mid md");
        $(this.searchResultItemsDiv).append(loader.getElement());

    }

    clearLoading() {
        $(this.searchResultItemsDiv).find(".loading-animation").remove();
    }

    clearResults() {
        $(this.searchResultItemsDiv).empty();
    }
}

class BookmarksPanel extends ToolPanel {
    currentBookmarkPage: number;
    paginator: Pagination;

    constructor(identificator: string, readerLayout: ReaderLayout, sc: ServerCommunication) {
        super(identificator, readerLayout, sc);
        this.currentBookmarkPage = 1;
    }

    public getPanelHtml(): HTMLDivElement {
        var panelDiv: HTMLDivElement = document.createElement("div");
        panelDiv.id = this.identificator;
        this.addPanelClass(panelDiv);
        panelDiv.appendChild(this.makeBody(this, window));
        return panelDiv;
    }

    protected makeBody(rootReference: Panel, window: Window): HTMLElement {
        var innerContent: HTMLDivElement = window.document.createElement("div");
        this.createBookmarkList(innerContent, rootReference);
        return innerContent;
    }

    public createBookmarkList(innerContent: HTMLElement, rootReference: Panel) {
        const bookmarksPerPage = 20;

        const $bookmarksContainer = $(innerContent).children(".reader-bookmarks-container");
        let bookmarksContainer: HTMLDivElement;

        if ($(innerContent).children(".reader-bookmarks-container").length === 0) {
            bookmarksContainer = document.createElement("div");
            bookmarksContainer.classList.add("reader-bookmarks-container");
            innerContent.appendChild(bookmarksContainer);
        } else {
            $bookmarksContainer.empty();
            bookmarksContainer = <HTMLDivElement>($bookmarksContainer.get(0) as Node);
        }

        var bookmarksHead = document.createElement("h2");
        bookmarksHead.innerHTML = localization.translate("AllBookmarks", "BookReader").value;
        bookmarksHead.classList.add("reader-bookmarks-head");
        bookmarksContainer.appendChild(bookmarksHead);

        var bookmarksContent = document.createElement("div");
        bookmarksContent.classList.add("reader-bookmarks-content");
        bookmarksContainer.appendChild(bookmarksContent);

        var bookmarks = rootReference.parentReader.getBookmarks();

        var pageInContainer: Array<HTMLUListElement> = [];
        var pagesContainer: HTMLDivElement = document.createElement("div");
        bookmarksContent.appendChild(pagesContainer);

        var paginationContainer: HTMLDivElement = document.createElement("div");
        paginationContainer.classList.add("reader-bookmarks-pagination");
        bookmarksContent.appendChild(paginationContainer);

        for (let i = 0; i < Math.ceil(bookmarks.totalCount / bookmarksPerPage); i++) {
            pageInContainer[i] = document.createElement("ul");
            pageInContainer[i].classList.add("reader-bookmarks-content-list");
            pageInContainer[i].setAttribute("data-page-index", (i + 1).toString());
            if (i !== this.currentBookmarkPage) {
                pageInContainer[i].classList.add("hide");
            }

            pagesContainer.appendChild(pageInContainer[i]);
        }

        var currentIndex = 0;
        for (let i = 0; i < bookmarks.positions.length; i++) {
            var bookmarkPosition = bookmarks.positions[i];
            for (let j = 0; j < bookmarkPosition.bookmarks.length; j++) {
                var bookmark = bookmarkPosition.bookmarks[j];
                var bookmarkElement = this.createBookmark(bookmark, rootReference, bookmarkPosition.pageIndex);
                pageInContainer[Math.floor(currentIndex / bookmarksPerPage)].appendChild(bookmarkElement);
                currentIndex++;
            }
        }
        if (this.paginator != null) {
            this.currentBookmarkPage = this.paginator.getCurrentPage();
        }

        this.paginator = new Pagination({
            container: paginationContainer,
            pageClickCallback: (pageNumber: number) => this.showBookmarkPage(pagesContainer, pageNumber),
            callPageClickCallbackOnInit: true
        });
        this.paginator.make(
            bookmarks.totalCount, bookmarksPerPage, this.currentBookmarkPage);

        $(".pagination", paginationContainer).addClass("pagination-extra-small");
    }

    protected showBookmarkPage(pagesContainer: HTMLDivElement, page: number) {
        $(pagesContainer).children().addClass("hide");
        $(pagesContainer).children(`[data-page-index="${page}"]`).removeClass("hide");
    }

    protected createBookmark(bookmark: IBookPageBookmark, rootReference: Panel, pageIndex: number) {
        const bookmarkItem = document.createElement("li");
        bookmarkItem.classList.add("reader-bookmarks-content-item");

        const bookmarkRemoveIco = document.createElement("a");
        bookmarkRemoveIco.href = "#";
        bookmarkRemoveIco.classList.add("glyphicon", "glyphicon-trash", "bookmark-remote-ico");
        bookmarkItem.appendChild(bookmarkRemoveIco);

        bookmarkRemoveIco.addEventListener("click", (e) => {
            e.preventDefault();

            rootReference.parentReader.persistRemoveBookmark(pageIndex, bookmark.id);
        });

        const bookmarkIco = document.createElement("span");
        bookmarkIco.classList.add("glyphicon", "glyphicon-bookmark", "bookmark-ico");
        if (bookmark.favoriteLabel) {
            $(bookmarkIco).css("color", bookmark.favoriteLabel.color);
            $(bookmarkIco).attr("title", bookmark.favoriteLabel.name);
        }
        bookmarkItem.appendChild(bookmarkIco);

        const pageInfo = rootReference.parentReader.getPageByIndex(pageIndex);
        const page = document.createElement("a");
        page.href = "#";
        $(page).text(pageInfo.text);
        page.classList.add("reader-bookmarks-content-item-page");

        const actionHook = () => {
            var pageId = bookmark.pageId;
            if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                $($(".view-control button")[1] as Node as HTMLElement).click();
            }
            this.parentReader.readerLayout.eventHub.emit("navigationClicked", pageId);
        };
        bookmarkIco.addEventListener("click", actionHook);
        page.addEventListener("click", actionHook);

        bookmarkItem.appendChild(page);
        bookmarkItem.appendChild(document.createTextNode(" "));

        const titleContainer = document.createElement("span");
        titleContainer.classList.add("reader-bookmarks-content-item-title-container");
        bookmarkItem.appendChild(titleContainer);

        const titleInput = document.createElement("input");
        titleInput.classList.add("reader-bookmarks-content-item-title-input", "hide");
        titleInput.value = bookmark.title;
        $(titleInput).attr("maxlength", FavoriteManager.maxTitleLength);
        bookmarkItem.appendChild(titleInput);

        const title = document.createElement("span");
        this.setBookmarkTitle(title, rootReference, bookmark.id, pageIndex, bookmark.title);
        title.classList.add("reader-bookmarks-content-item-title");

        titleContainer.addEventListener("click", () => {
            titleContainer.classList.add("hide");
            titleInput.classList.remove("hide");

            titleInput.focus();
        });

        const updateHook = () => {
            this.setBookmarkTitle(title, rootReference, bookmark.id, pageIndex, titleInput.value);

            titleInput.classList.add("hide");
            titleContainer.classList.remove("hide");
        };
        titleInput.addEventListener("blur", updateHook);
        titleInput.addEventListener("keyup", (e: KeyboardEvent) => {
            if (e.keyCode === 13) {
                updateHook();
            }
        });

        titleContainer.appendChild(title);
        titleContainer.appendChild(document.createTextNode(" "));

        const titleEdit = document.createElement("span");
        titleEdit.classList.add("glyphicon", "glyphicon-pencil", "edit-button");
        titleContainer.appendChild(titleEdit);

        return bookmarkItem;
    }

    protected setBookmarkTitle(titleItem: HTMLElement, rootReference: Panel, bookmarkId: number, pageIndex: number, title: string) {
        rootReference.parentReader.setBookmarkTitle(bookmarkId, pageIndex, title);

        if (!title) {
            title = localization.translate("NoName", "BookReader").value;
        }

        $(titleItem).text(title);
    }

}

abstract class TermsPanel extends ToolPanel {
    protected termClickedCallback: (termId: number, text: string) => void;

    setTermClickedCallback(callback: (termId: number, text: string) => void) {
        this.termClickedCallback = callback;
    }


}

class TermsSearchPanel extends TermsPanel {
    private searchResultItemsDiv: HTMLDivElement;
    private searchResultOrderedList: HTMLOListElement;

    private searchResultItemsLoadDiv: HTMLDivElement;

    makeBody(rootReference: Panel, window: Window): HTMLElement {
        var searchResultDiv = window.document.createElement("div");
        $(searchResultDiv)
            .addClass("reader-search-result-div")
            .append(`<h3>${localization.translate(this.identificator, "BookReader").value} </h3>`);

        var searchResultItemsLoadDiv = window.document.createElement("div");
        $(searchResultItemsLoadDiv).addClass("reader-terms-search-result-items-div-load");
        var loader = lv.create(null, "lv-dots lv-mid md");
        $(searchResultItemsLoadDiv).append(loader.getElement());
        this.searchResultItemsLoadDiv = searchResultItemsLoadDiv;
        $(searchResultItemsLoadDiv).hide();
        searchResultDiv.appendChild(searchResultItemsLoadDiv);

        var searchResultItemsDiv = window.document.createElement("div");
        $(searchResultItemsDiv).addClass("reader-terms-search-result-items-div");
        this.searchResultItemsDiv = searchResultItemsDiv;
        searchResultDiv.appendChild(searchResultItemsDiv);

        this.searchResultOrderedList = window.document.createElement("ol");

        this.searchResultItemsDiv.appendChild(this.searchResultOrderedList);

        this.clearResults();
        return searchResultDiv;
    }

    showLoading() {
        $(this.searchResultItemsDiv).hide();
        $(this.searchResultItemsLoadDiv).show();

    }

    clearLoading() {
        $(this.searchResultItemsLoadDiv).hide();
        $(this.searchResultItemsDiv).show();
    }

    clearResults() {
        $(this.searchResultOrderedList).empty();
        $(this.searchResultOrderedList).append(localization.translate("UseSearch", "BookReader").value);
        $(this.searchResultOrderedList).addClass("no-items");
    }

    showResults(searchResults: PageDescription[]) {
        $(this.searchResultOrderedList).empty();
        $(this.searchResultOrderedList).removeClass("no-items");

        for (var i = 0; i < searchResults.length; i++) {
            var result = searchResults[i];
            var resultItem = this.createResultItem(result);
            this.searchResultOrderedList.appendChild(resultItem);
        }

        if (searchResults.length === 0) {
            $(this.searchResultOrderedList).addClass("no-items");
            $(this.searchResultOrderedList).append(localization.translate("NoOccurrencesOnPage", "BookReader").value);
        }
    }

    showError(error: JQueryXHR) {
        $(this.searchResultOrderedList).empty();
        $(this.searchResultOrderedList).removeClass("no-items");
        const alert = new AlertComponentBuilder(AlertType.Error).addContent(this.errorHandler.getErrorMessage(error));
        $(this.searchResultOrderedList).append(alert.buildElement());
    }

    private createResultItem(page: PageDescription): HTMLLIElement {
        var resultItemListElement = document.createElement("li");

        var hrefElement = document.createElement("a");
        hrefElement.href = "#";
        $(hrefElement).click(() => {
            if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                $($(".view-control button")[1] as Node as HTMLElement).click();
            }
            this.parentReader.readerLayout.eventHub.emit("navigationClicked", page.id);
        });
        this.parentReader.readerLayout.on("itemCreated", () => {
            $(hrefElement).click(() => {
                if (this.parentReader.deviceType === Device.Mobile && !$(".lm_popin").is("div")) {
                    $($(".view-control button")[1] as Node as HTMLElement).click();
                }
                this.parentReader.readerLayout.eventHub.emit("navigationClicked", page.id);
            });
        });

        var textSpanElement = document.createElement("span");
        $(textSpanElement).text(`[${page.name}]`);

        $(hrefElement).append(textSpanElement);

        $(resultItemListElement).append(hrefElement);

        return resultItemListElement;
    }
}

class TermsResultPanel extends TermsPanel {

    private termsResultItemsDiv: HTMLDivElement;
    private termsOrderedList: HTMLOListElement;

    private termsResultItemsLoadDiv: HTMLDivElement;

    makeBody(rootReference: Panel, window: Window): HTMLElement {
        var termsResultDiv = window.document.createElement("div");
        $(termsResultDiv)
            .addClass("reader-terms-result-div")
            .append(`<h3>${localization.translate(this.identificator, "BookReader").value} </h3>`);

        var termsResultItemsLoadDiv = window.document.createElement("div");
        $(termsResultItemsLoadDiv).addClass("reader-terms-result-items-div-load");
        var loader = lv.create(null, "lv-dots lv-mid md");
        $(termsResultItemsLoadDiv).append(loader.getElement());
        this.termsResultItemsLoadDiv = termsResultItemsLoadDiv;
        $(termsResultItemsLoadDiv).hide();
        termsResultDiv.appendChild(termsResultItemsLoadDiv);

        var termsResultItemsDiv = window.document.createElement("div");
        $(termsResultItemsDiv).addClass("reader-terms-result-items-div");
        this.termsResultItemsDiv = termsResultItemsDiv;
        termsResultDiv.appendChild(termsResultItemsDiv);

        this.termsOrderedList = window.document.createElement("ol");

        this.termsResultItemsDiv.appendChild(this.termsOrderedList);

        const currentPage = this.parentReader.bookHeader.pages[
            this.parentReader.currentPageIndex];

        this.loadTermsOnPage(currentPage);

        if (typeof this.termClickedCallback === "undefined") {
            this.termClickedCallback = (termId: number, text: string) => {
                window.location.href = getBaseUrl() + "OldGrammar/OldGrammar/Search?search=" + text;
            };
        }
        return termsResultDiv;
    }

    public onMoveToPage(pageIndex: number, scrollTo: boolean) {
        var page = this.parentReader.getPageByIndex(pageIndex);
        this.loadTermsOnPage(page);
    }

    private loadTermsOnPage(page: BookPage) {

        $(this.termsOrderedList).empty();
        $(this.termsOrderedList).removeClass("no-items");
        $(this.termsResultItemsLoadDiv).show();
        $(this.termsResultItemsDiv).hide();
        var terms: JQueryXHR = this.sc.getTerms(this.parentReader.bookId, page.pageId);
        terms.done((response: { terms: Array<ITermContract> }) => {

            $(this.termsOrderedList).empty();
            $(this.termsOrderedList).removeClass("no-items");
            $(this.termsResultItemsLoadDiv).hide();
            $(this.termsResultItemsDiv).show();

            for (var i = 0; i < response.terms.length; i++) {
                var term = response.terms[i];
                this.termsOrderedList.appendChild(this.createTermItem(term.id, term.name));
            }

            if (response.terms.length === 0 && this.termsOrderedList.innerHTML === "") {
                $(this.termsOrderedList).addClass("no-items");
                $(this.termsOrderedList).append(localization.translate("NoTopicOnPage", "BookReader").value);
            }

        });
        terms.fail(() => {
            if (page.pageId === this.parentReader.getCurrentPage().pageId) {
                $(this.termsResultItemsLoadDiv).hide();
                $(this.termsResultItemsDiv).show();
                $(this.termsOrderedList).addClass("no-items");
                $(this.termsOrderedList).append(localization.translateFormat("LoadingTopicsError", new Array<string>(page.text), "BookReader").value);
            }
        });
    }

    private createTermItem(termId: number, text: string): HTMLLIElement {
        var termItemListElement = document.createElement("li");

        var hrefElement = document.createElement("a");
        hrefElement.href = "#";
        $(hrefElement).click(() => {
            if (typeof this.termClickedCallback !== "undefined" && this.termClickedCallback !== null) {
                this.termClickedCallback(termId, text);
            }
        });
        this.parentReader.readerLayout.on("itemCreated", () => {
            $(hrefElement).click(() => {
                if (typeof this.termClickedCallback !== "undefined" && this.termClickedCallback !== null) {
                    this.termClickedCallback(termId, text);
                }
            });
        });

        var textSpanElement = document.createElement("span");
        $(textSpanElement).text(`[${text}]`);

        $(hrefElement).append(textSpanElement);

        $(termItemListElement).append(hrefElement);

        return termItemListElement;
    }
}

//end of tool panels

abstract class ContentViewPanel extends Panel {
    addPanelClass(sidePanelDiv: HTMLDivElement): void {
        $(sidePanelDiv).addClass("reader-view-panel");
    }
}

// NOTE: available as reader.textPanel in the console (for analysis)
class TextPanel extends ContentViewPanel {
    /**
     * xml:id of the bearer of a milestone, which is either a witness in listWit
     * or an edition in listBibl
     */
    sourceId: string;

    preloadPagesBefore: number;
    preloadPagesAfter: number;

    private query: string; //search for text search
    private queryIsJson: boolean;

    // TODO: (again), instead of having several distinct sets of related state,
    //       rather have a single dictionary/object and keep all the state there
    //       (but make these sets available through filtering of the common state)

    /**
     * xml:ids of paragraphs and other parts of the document so far only
     * requested, so we don’t try to fetch them more than once
     */
    requestedParts: Set<string>;
    // NOTE: available as reader.textPanel.requestedParts in the console

    /**
     * xml:ids of paragraphs and other parts of the document already fetched
     * and currently displayed
     */
    loadedParts: Set<string>;
    // NOTE: available as reader.textPanel.loadedParts in the console

    // private incompletePages: Array<{ page: BookPage, pageContainer: HTMLElement }>;
    // https://levelup.gitconnected.com/building-type-safe-dictionaries-in-typescript-a072d750cbdf
    private incompletePages: { [pagePosition: number]: { pageName: string, pageContainer: HTMLElement } };
    // Record<number, { page: BookPage, pageContainer: HTMLElement }>;

    private _pagesWithNotesToCollect: Array<{ page: BookPage, pageContainer: HTMLElement }>;
    viewer: EditionsViewer;

    // true after some page successfully loaded; false before any does and after any fails
    private _serverConnectionWorking: boolean;

    constructor(identificator: string, readerLayout: ReaderLayout, sc: ServerCommunication) {
        super(
            identificator, readerLayout, sc,
            // createBodyEarly – certainly not, we want to be able to INITIALIZE
            // this.sourceId first, you ******
            false);

        // const defaults = this.readerLayout.defaults;

        this.sourceId = this.readerLayout.sourceId;

        this.preloadPagesBefore = 2; // OLD: 5
        this.preloadPagesAfter = 3; // OLD: 10

        this.requestedParts = new Set<string>();
        this.loadedParts = new Set<string>();

        // TODO: drop this one property
        this.incompletePages = {};
        this._pagesWithNotesToCollect = [];

        this.viewer = new EditionsViewer();

        this.viewer.setup({
            // root: document.querySelector('div#ReaderBodyDiv')
            root: this.parentReader.readerLayout.container[0],
            chars_in_page: 1800, // TODO: make this actually configurable
            bail_on_incomplete_paragraphs: true, // TODO: this should be temporary
        });

        // TODO: prevent the requesting several pages in parallel by delaying
        //       and batching
        this._serverConnectionWorking = true;
    }

    /**
     *  XXX: this really should not be invoked from the parent class’ constructor
     *       before our constructor could provide additional data, ffs!
     */
    protected makeBody(rootReference: Panel, window: Window): HTMLElement {
        var textContainerDiv: HTMLDivElement = window.document.createElement("div");

        const defaults = this.parentReader.defaults;
        // DONE: this may be ambiguous due to pageIds (see UpdatePagesSubtask),
        //       thus use pagesByXmlIds
        // const pagesById = this.parentReader.pagesById;
        const pagesByXmlIds = this.parentReader.pagesByXmlIds;

        // NOTE: an array is okay, we’re on jQuery 3.4.1
        const classNames = ['reader-text-container'];

        if (defaults.showPageNames)
            classNames.push('reader-text-show-page-names');

        if (defaults.showApparatus)
            classNames.push('show-notes');

        $(textContainerDiv).addClass(classNames);

        // console.info('Source for pagination (witnessXmlId):', this.sourceId);

        document.addEventListener("scroll", (event) => {
            //  DONE: do nothing if we’ve just jumped manually
            //  DONE: check this.parentReader.clickedMoveToPage, maybe?
            //   XXX: but make sure to reset it when we actually do click and jump
            if (this.parentReader.clickedMoveToPage) {
                this.parentReader.clickedMoveToPage = false;
                return;
            }

            if (!$(event.target).hasClass("reader-text-container")) {
                return
            }
            this.parentReader.clickedMoveToPage = false;

            //  OLD: div.page (drop these eventually?)
            //  OLD: const pages = $(event.target as Node as HTMLElement).find('.itj-pb');
            const container = event.target as Node as HTMLElement;
            const pages = container.querySelectorAll(
                `.itj-pb[data-source-id = '${this.sourceId}']`);

            var minOffset = Number.MAX_VALUE;
            var pageWithMinOffset;
            $.each(pages, (index, page: HTMLElement) => {
                var pageOfsset = Math.abs($(page).offset().top - $(event.target as Node as HTMLElement).offset().top);
                if (minOffset > pageOfsset) {
                    minOffset = pageOfsset;
                    pageWithMinOffset = page;
                }
            });

            const pageBreakId: string = pageWithMinOffset.id;
            const page: BookPage = pagesByXmlIds[pageBreakId];

            if (!page) {
                console.warn(
                    'pagesByXmlIds doesn’t seem to contain', pageBreakId,
                    'so maybe this document should be reuploaded and reprocessed');

                return;
            }

            //  XXX: page-5 and page-ed-5 were mapped to the same Resource(Page)
            //       when numeric pageIds (not unique!) were used everywhere and
            //       not the xml:ids, yet
            //  XXX: this should no longer happen but let’s keep the check, to be safe
            if (page.witnessXmlId !== this.sourceId) {
                console.warn(
                    'Page matched by a numeric (DB) ID belongs to a different ' +
                    'witness, ignoring', page);

                return;
            }

            // NOTE: this invokes a callback in ReaderLayout.addListeners and
            //       in turn, ReaderPagination.moveToPage
            // NOPE: rather send the whole BookPage object, for ****’s sake
            //       (well, the xml:id is just as a good, maybe better)
            // TODO: but still, drop the numeric IDs that come from the DB
            this.parentReader.readerLayout.eventHub.emit(
                'scrollPage', page.pageId, page.xmlId);
        }, true);

        // XXX: the event handler must only be BOUND once, not on every 'scroll' event, as it used to
        this.parentReader.readerLayout.eventHub.on('toggleComments', (isChecked: boolean, className: string) => {
            if (isChecked) {
                $(this.innerContent).addClass(className);
            } else {
                $(this.innerContent).removeClass(className);
            }
        });

        var textAreaDiv: HTMLDivElement = window.document.createElement("div");
        $(textAreaDiv).addClass("reader-text");

        for (var i = 0; i < rootReference.parentReader.bookHeader.pages.length; i++) {
            let page: BookPage = rootReference.parentReader.bookHeader.pages[i];

            var pageTextDiv: HTMLDivElement = window.document.createElement("div");
            $(pageTextDiv).addClass("page");
            $(pageTextDiv).addClass("unloaded");
            // .data is not visible
            $(pageTextDiv).data("page-name", page.text);
            // .attr is visible
            $(pageTextDiv).attr("data-page-name", page.text);
            $(pageTextDiv).attr("data-page-xmlId", page.pageId);
            pageTextDiv.id = page.pageId.toString(); // each page has own id

            var pageDiv: HTMLDivElement = window.document.createElement("div");
            $(pageDiv).addClass("page-wrapper");
            $(pageDiv).append(pageTextDiv);
            textAreaDiv.appendChild(pageDiv);
        }

        var dummyPage: HTMLDivElement = window.document.createElement("div");
        $(dummyPage).addClass("dummy-page");
        textAreaDiv.appendChild(dummyPage);

        textContainerDiv.appendChild(textAreaDiv);
        return textContainerDiv;
    }

    public onMoveToPage(pageIndex: number, scrollTo: boolean) {
        //fetch page only if exist
        this.parentReader.hasBookPage(this.parentReader.bookId, this.parentReader.versionId, () => {
            const pages: BookPage[] = this.parentReader.bookHeader.pages;

            // DONE: unless there’s been some error fetching some page before – and also initially
            if (this._serverConnectionWorking) {
                for (var j = 1; pageIndex - j >= 0 && j <= this.preloadPagesBefore; j++) {
                    this.displayPage(pages[pageIndex - j], false);
                }

                for (var i = 1; pageIndex + i < pages.length && i <= this.preloadPagesAfter; i++) {
                    this.displayPage(pages[pageIndex + i], false);
                }
            }

            this.displayPage(pages[pageIndex], scrollTo);
        });
    }

    displayPage(page: BookPage, scrollTo: boolean, onSuccess: () => any = null, onFailed: () => any = null) {
        // XXX: onSuccess doesn't seem to be used (anymore)
        if (onSuccess)
            console.log('displayPage onSuccess:', onSuccess);

        var pageDiv = document.getElementById(page.pageId.toString());
        var pageLoaded: boolean = !($(pageDiv).hasClass("unloaded"));
        var pageSearchUnloaded: boolean = $(pageDiv).hasClass("search-unloaded");
        var pageLoading: boolean = $(pageDiv).hasClass("loading-page");
        if (!pageLoading) {
            if (pageSearchUnloaded) {
                this.downloadSearchPageById(this.query, this.queryIsJson, page, onSuccess, onFailed);
            } else if (!pageLoaded) {
                this.downloadPageById(page, onSuccess, onFailed);
            } else if (onSuccess !== null) {
                onSuccess();
            }
        } else if (onSuccess !== null) {
            onSuccess();
        }

        if (scrollTo && pageLoaded) {
            const pageBreak: HTMLElement = document.querySelector(
                `a.itj-pb[data-page-name="${page.text}"]`);

            if (!pageBreak) {
                console.info('Page break', page.text, 'not found.');
                return;
            }

            // NOPE: iterate to the next element that has an offset parent
            //       (<template> is also 'display: none' so skip that) and jump
            //       to its location instead
            // DONE: the page breaks are now always displayed and act as wrappers
            //       to the text that is either rendered or not at all
            //  XXX: this condition should not hold ever again
            if (pageBreak.offsetParent === null) {
                console.error(
                    'Page break', pageBreak,
                    'is not displayed, cannot scroll –',
                    // NOTE: not even Firefox Developer Tools could
                    'THIS SHOULD NOT BE HAPPENING!',
                    'XXX: fix XSLT and CSS if it is');

                return;
            }

            this.scrollTextToPositionFromTop(0);
            const offset = $(pageBreak).offset(); // DONE: use the pagination anchor instead of pageDiv
            if (offset != undefined) {
                this.scrollTextToPositionFromTop(offset.top);
            }

        }
    }

    scrollTextToPositionFromTop(topOffset: number) {
        var scrollableContainer = $(this.innerContent);
        var containerTopOffset = $(scrollableContainer).offset().top;
        $(scrollableContainer).scrollTop(topOffset - containerTopOffset);
    }

    private downloadPageById(page: BookPage, onSuccess: () => any = null, onFailed: () => any = null) {
        if (debugEnableFolios.length && debugEnableFolios.indexOf(page.text) == -1) {
            // only display the debug warning once for each page not to clutter the console
            if (debugFoliosWarned[page.text])
                return;

            debugFoliosWarned[page.text] = true;

            console.log(`To fetch&display page ${page.text} (${page.pageId}), add the folio name to the "debugEnableFolios" global array like this:`);
            console.log(`debugEnableFolios.push('${page.text}'); // ${page.pageId}`);
            return;
        }

        var pageContainer = document.getElementById(page.pageId.toString());
        var loader = lv.create(null, "lv-circles lv-mid sm");
        $(pageContainer)
            .addClass("loading-page")
            .append(loader.getElement());

        const debugLogging = true;

        // DONE: try to serialize the result as a dictionary with xml:ids as keys
        //       and rendered HTML as string values – already in eXist-db
        //       (well, that was a pain but could be done, somehow)
        // DONE: then it will be easier to weed out and/or request only the xml:ids
        //       we don’t yet have (now we’re getting duplicated paragraphs –
        //       on purpose)
        const partIds = page.partXmlIds.filter((partId: string) =>
        {
            const ret =
                !this.requestedParts.has(partId) &&
                !this.loadedParts.has(partId);

            if (debugLogging) {
                if (ret)
                    console.info(
                        page.text, 'We don’t have or haven’t requested',
                        partId, 'yet.');

                else
                    console.info(
                        page.text, 'Not requesting', partId, 'again, it’s',
                        'either being requested or already loaded.');
            }

            return ret;
        });

        if (!partIds.length) {
            $(pageContainer).empty();
            $(pageContainer).removeClass("loading-page");
            $(pageContainer).removeClass("unloaded");

            return;
        }

        for (let partId of partIds) {
            if (debugLogging) {
                console.info(
                    page.text, 'Marking', partId, 'as being or having been',
                    'requested.');
                }

            this.requestedParts.add(partId);
        }

        const bookPage: JQueryXHR = this.sc.getDocumentParts(
            this.parentReader.versionId,
            // NOTE: front and back matter is not likely to contain page breaks
            //       and so shall be retrieved through an xml:id on a div or something
            // 'front-1 front-2 body-1 body-2'.split(' '),
            partIds,
        );

        bookPage.done((response: {
            PageItems: {[key: string]: string},
            // timings
            ExistRoundtrip: string, // TimeSpan
        }) => {
            this._serverConnectionWorking = true;

            // extract (only) the requested xml:ids
            const gotParts = response.PageItems;
            const parts = {};

            for (let partId of partIds) {
                const part = gotParts[partId];

                if (part)
                    parts[partId] = part;
            }

            const filteredPartIds = Object.keys(parts);
            const pageText = filteredPartIds.map(
                partId => parts[partId]).join('\n');

            // NOTE: yep, even if we didn’t receive all requested parts, we won’t
            //       keep them in the “requested” state forever and also declare
            //       them (falsely) as successfully fetched
            // TODO: if we really didn’t get a requested part, stick it in a set
            //       of “fake-loaded” parts…?
            // TODO: not another set – merge all state in a single dict/object
            for (let partId of partIds) {
                if (debugLogging) {
                    console.info(
                        page.text, 'Marking', partId, 'as no longer being',
                        'requested but rather successfully loaded (whether or',
                        'not truly fetched).');
                }

                this.requestedParts.delete(partId);
                this.loadedParts.add(partId);
            }

            // this.preprocessPage(page, response, pageContainer);
            $(pageContainer).empty();
            $(pageContainer).append(pageText);
            $(pageContainer).removeClass("loading-page");
            $(pageContainer).removeClass("unloaded");

            // page postprocessing
            // this._collectFootnotes({page, pageContainer});
            this._renderFootnotes({page, pageContainer});
            activateTooltips(page, pageContainer);
            //  XXX: this is also the old page splitting+joining code
            if (false)
            this.postprocessPage(page, pageContainer);
            // DONE: disable
            // TODO: move out… (and maybe reuse the concept if we choose
            //       to split long tables or lists…)
            // DONE: really do drop this, as some pages/paragraphs are being
            //       hidden due to being mistaken by an old heuristic
            if (false)
            this.joinParagraphs();

            if (this.parentReader.clickedMoveToPage) {
                this.parentReader.bookHeader.moveToPageNumber(
                    this.parentReader.currentPageIndex, true);
            }

            if (onSuccess != null) {
                onSuccess();
            }
        });

        bookPage.fail(() => {
            this._serverConnectionWorking = false;

            for (let partId of partIds) {
                if (debugLogging) {
                    console.info(
                        page.text, 'Marking', partId, 'as no longer being',
                        'requested due to a failure.');
                }

                // TODO: keep track of the failed parts to perhaps request them
                //       again later
                // TODO: if kept in a common state (with xml:ids as keys) we could
                //       have timestamps to impose reasonable delays, count the
                //       number of failures, and other stuff (to either become robust
                //       or too complex and thus fragile/brittle, we don’t know yet)
                this.requestedParts.delete(partId);
            }

            $(pageContainer).empty();
            $(pageContainer).removeClass("loading-page");
            $(pageContainer).append(localization.translateFormat("PageLoadingError", new Array<string>(page.text), "BookReader").value);

            if (onFailed != null) {
                onFailed();
            }
        });
    }

    private downloadSearchPageById(query: string, queryIsJson: boolean, page: BookPage, onSuccess: () => any = null, onFailed: () => any = null) {
        var pageContainer = document.getElementById(page.pageId.toString());
        var loader = lv.create(null, "lv-circles lv-mid sm");
        $(pageContainer)
            .addClass("loading-page")
            .append(loader.getElement());
        var bookPage: JQueryXHR = this.sc.getBookPageSearch(this.parentReader.versionId, page.pageId, queryIsJson, query);
        bookPage.done((response: { pageText: string }) => {
            $(pageContainer).empty();
            $(pageContainer).append(response.pageText);
            $(pageContainer).removeClass("loading-page");
            $(pageContainer).removeClass("unloaded");
            $(pageContainer).removeClass("search-unloaded");
            $(pageContainer).addClass("search-loaded");

            if (this.parentReader.clickedMoveToPage) {
                this.parentReader.bookHeader.moveToPageNumber(
                    this.parentReader.currentPageIndex, true);
            }

            if (onSuccess != null) {
                onSuccess();
            }
        });

        bookPage.fail(() => {
            $(pageContainer).empty();
            $(pageContainer).removeClass("loading");
            $(pageContainer).append(localization.translateFormat("PageLoadingErrorWithSearchResults", new Array<string>(page.text), "BookReader").value);

            if (onFailed != null) {
                onFailed();
            }
        });
    }

    public setSearchedQuery(query: string, isJson: boolean) {
        this.query = query;
        this.queryIsJson = isJson;
    }

    private preprocessPage(page: BookPage, response: { pageText: string }, pageContainer: HTMLElement)
    {
        //
    }

    private postprocessPage(page: BookPage, pageContainer: HTMLElement) // XXX: rename to something more specific or split
    {
        let lastParagraph = pageContainer.querySelector('.itj-page > :last-child') as HTMLElement; // p, h3 (BiblBoc_Mc)
        // console.log('lastParagraph', lastParagraph);

        if (lastParagraph === null) {
            console.log('no paragraph!', page); // this breaks logic; TODO: empty pages have no business being sent to the reader
            return;
        }

        let incomplete = this.isParagraphIncomplete(lastParagraph, lastParagraph); // not wrapped yet

        if (incomplete) { // .incomplete-paragraph or .ends-with-incomplete-word
            // $(lastParagraph).addClass(incomplete); // XXX: the class is added already in eXist (commonToHtml-block.xsl)

            this.incompletePages[page.position] = { pageName: page.text, pageContainer };

            // XXX: hopefully this won’t be necessary with explicit wrapping of
            //      whitespace-sensitive runs in spans in editions_whitespace.xsl?
            if (incomplete == 'ends-with-incomplete-word' && lastParagraph.childNodes.length) {
                let lastNode = lastParagraph.childNodes[lastParagraph.childNodes.length - 1];

                if (lastNode.nodeType != 3) // not #text, likely already a span (XSL changed)
                    return;

                // console.log('XXX: ensure no trailing whitespace here', lastParagraph, lastNode);

                // XXX: later! Property 'trimEnd' does not exist on type 'string'. Do you need to change your target library? Try changing the 'lib' compiler option to 'es2019' or later.ts(2550)
                // @ts-ignore
                lastNode.nodeValue = lastNode.nodeValue.trimEnd();
            }
        }
    }

    private isParagraphIncomplete(paragraph: HTMLElement, paragraph_contents: HTMLElement): 'incomplete-paragraph' | 'ends-with-incomplete-word' | null
    {
        for (let marker of [
            'incomplete-paragraph',
            'ends-with-incomplete-word',
        ]) {
            if (paragraph.classList.contains(marker))
                // Type 'string' is not assignable to type '"incomplete-paragraph" | "ends-with-incomplete-word"'.ts(2322)
                // @ts-ignore
                return marker;
        }

        return null;

        // Paragraphs are now be marked as “incomplete”
        // whenever they contain a page (~~and optionally, column~~) break – already
        // when creating TEI + in an xquery (well, rather in XSL, right?).
    }

    private joinParagraphs()
    {
        let numbers = Object.keys(this.incompletePages);

        // for (let num in this.incompletePages) {
        for (let num of numbers) {
            let { pageName, pageContainer} = this.incompletePages[num];
            let thisPageWrapper = pageContainer.parentElement;
            let nextPageWrapper = thisPageWrapper.nextElementSibling;

            if (!nextPageWrapper) {
                // XXX: this should never happen: incomplete pages should be followed by a continuation...
                continue;
            }

            let incompleteParagraph = pageContainer.querySelector('.itj-page > :last-child');
            let attachedContinuations = incompleteParagraph.hasAttribute('data-continuations') ?
                incompleteParagraph.getAttribute('data-continuations').split(' ') :
                [];

            if (attachedContinuations.length && attachedContinuations[0] === '')
                attachedContinuations.shift();

            // own content of the receiving paragraph must be wrapped as well
            this.wrapOwnContent(incompleteParagraph);

            // regarding the 'attachedContinuations' array: https://stackoverflow.com/questions/7744611/pass-variables-by-reference-in-javascript#comment72968544_26610095
            this.attachContinuations(
                // XXX: try to reduce the number of parameters, group them in an object
                //      if that makes sense (more than an arbitrary grouping),
                //      and mark the ones / those that get modified (`attachedContinuations`)
                //      ... or maybe return a new list instead of a modification
                num, pageName, nextPageWrapper, incompleteParagraph,
                attachedContinuations);

            incompleteParagraph.setAttribute('data-continuations', attachedContinuations.join(' '));
        }
    }

    // NOTE: notes are placed (somewhere) inside the pages, not potentially after every page
    private attachContinuations(num: string, pageName: string, nextPageWrapper: HTMLElement,
                                incompleteParagraph: HTMLElement, continuations: string[])
    {
        let continuation = null;
        let continuationSource = null;
        let pageIsOnlyContinuation = false;
        let continuationIsIncomplete = null;

        while (nextPageWrapper) {
            let nextPage = nextPageWrapper.firstElementChild as HTMLElement; // .page(.unloaded)
            if (nextPage === null)
                break; // div.dummy-page

            // tsconfig.json fix inspired by: https://stackoverflow.com/questions/42790602/how-do-i-check-whether-an-array-contains-a-string-in-typescript#comment95635337_42790792
            if (continuations.includes(nextPage.id)) {
                nextPageWrapper = nextPageWrapper.nextElementSibling as HTMLElement;
                continue;
            }

            if (!this.canJoinParagraph(nextPage))
                return;

            continuation = nextPage.querySelector('.itj-page > :first-child') as HTMLElement;
            if (!continuation) {
                console.log(pageName, incompleteParagraph, 'empty, useless page??', nextPage);

                // declare (fake) success
                // TODO: clean up this mess
                continuation = nextPage;
                continuationSource = null;
            }

            // DONE: it still happens that partial pages/paragraphs appear where they
            //       shouldn’t, e.g. the last paragraph in 203r (AdamM) should only be completed
            //       by one from 203v and that’s it, not anything from 204r+v
            // XXX: when heuristics goes bad (the "incomplete" paragraph is in fact complete but misdetected)
            //      it may happen that the "next paragraph" is in fact a pagination (as long as it is placed outside paragraphs!)
            // XXX: let's add one more rule to disallow merging that... even though the paragraph/page won't give up trying (TODO)
            // <a class="info itj-pb space" data-page-name="133v">[133v]<span class="tooltip">číslo strany rukopisu</span></a>
            if (continuation.nodeName == 'A')
                return;

            // XXX: also, can't joinParagraph infer `nextPage` as a parent of `continuation`?
            continuationSource = this.joinParagraph(incompleteParagraph, nextPage, continuation, pageName);
            if (continuationSource === null) { // already joined, let's proceed to the next continuation
                nextPageWrapper = nextPageWrapper.nextElementSibling as HTMLElement;
                continue;
            }

            if (!continuations.includes(nextPage.id))
                continuations.push(nextPage.id);

            // hide even page wrappers consisting solely of an incomplete paragraph
            pageIsOnlyContinuation = !continuation.nextElementSibling;
            if (pageIsOnlyContinuation) {
                console.warn(
                    'OLD: marking', nextPage, 'as a continuation; TODO: remove');
                $(nextPage).addClass('continuation');
            }

            // TODO: after this function finishes, really check that it holds for all blocks
            //       that they are displayed either inline (as a continuation) or as (the original) block
            // XXX:  if the check fails (not displayed at all, or shown twice),
            //       report that to the user or to the server

            continuationIsIncomplete = this.isParagraphIncomplete(continuation, continuationSource);
            if (continuationIsIncomplete === null) {
                // With this continuation the paragraph is complete.
                $(incompleteParagraph).addClass('completed-paragraph');
                break;
            }

            nextPageWrapper = nextPageWrapper.nextElementSibling as HTMLElement;
        }

        if (continuation) {
            delete this.incompletePages[num];

            if (!incompleteParagraph.classList.contains('ends-with-incomplete-word'))
                return;

            if (continuationIsIncomplete != 'ends-with-incomplete-word')
                $(incompleteParagraph).addClass('completed-paragraph');
        }
    }

    private canJoinParagraph(nextPage: HTMLElement): boolean
    {
        return !nextPage.classList.contains('unloaded');
    }

    private joinParagraph(incompleteParagraph: HTMLElement, nextPage: HTMLElement, continuation: HTMLElement, pageName: string): HTMLElement
    {
        let id = `continuation-${pageName}-${nextPage.id}`;
        if (document.getElementById(id))
            return null;

        let continuationSource = this.wrapOwnContent(continuation);

        // XXX: do this later – why hide the paragraph if it might be shown again soon
        //      (when the previous page has notes)
        $(continuation).addClass('continuation');
        console.warn(
            'OLD: marking', continuation, 'as a continuation; TODO: remove');

        // DONE:  pozor, kopírovat pouze vlastní text pokračujícího odstavce,
        //        rozhodně ne do něj vložené části dalších odstavců!
        // DONE:  pomohlo by, kdyby z ~~xquery (XSL) lezly~~ ++dělá se to přímo tady++ odstavce s vlastním textem
        //        vloženým pro jednoduchost ještě v adekvátně označeném spanu (.own-text?)
        let applied = document.createElement('span');
        applied.id = id;
        applied.className = 'continuation';
        applied.innerHTML = continuationSource.innerHTML;
        incompleteParagraph.appendChild(applied);

        console.warn(
            'OLD: marking', applied, 'as a continuation; TODO: remove');

        // DONE: footnotes in the continuations didn’t have their popups initialized
        activateTooltips(null, applied);

        console.log(pageName, incompleteParagraph, continuation, continuationSource);
        return continuationSource;
    }

    private wrapOwnContent(paragraph: HTMLElement): HTMLElement
    {
        let content = paragraph.querySelector('span.own-content') as HTMLElement;

        if (content === null) {
            $(paragraph).wrapInner('<span class="own-content"></span>');
            content = paragraph.querySelector('span.own-content');
        }

        return content;
    }

    // XXX: why is this in TextPanel / panels.ts? it doesn’t sound much like an “e-book reader”
    // NOTE: this applies to a good part of the TextPanel stuff
    // TODO: so just split the file and put components in their own modules
    //       (they will appear with progressive reimplementation in React)

    // OLD:  does TypeScript allow this to be called without parameters?
    // DONE: perhaps we don’t need to care as it should be the last page loaded
    //       that triggers the last loop collecting the remainder of notes
    //  OLD: _collectFootnotes
    private _renderFootnotes(pageInfo: {page: BookPage, pageContainer: HTMLElement})
    {
        this._pagesWithNotesToCollect.push(pageInfo);
        let pageIndex = 0;

        while (pageIndex < this._pagesWithNotesToCollect.length) {
            const { page, pageContainer } = this._pagesWithNotesToCollect[pageIndex];

            // const copied = this._collectFootnotesFromPage(page, pageContainer);
            const rendered = this._renderFootnotesInPage(page, pageContainer);

            // if (copied) {
            if (rendered) {
                const removed = this._pagesWithNotesToCollect.splice(pageIndex, 1);
                // console.log('Collected:', removed);

            } else
                pageIndex++;
        }

        // console.log(this._pagesWithNotesToCollect);
    }

    private _renderFootnotesInPage(page: BookPage, pageContainer: HTMLElement): boolean
    {
        this.viewer.root = pageContainer;

        const ret = this.viewer.createFootnotesInWholeDocument();

        if (!ret)
            return false;

        return true;
    }

    //  XXX: this seems to only work with notes pre-rendered into footnote
    //       containers which no longer happens
    private _collectFootnotesFromPage(page: BookPage, pageContainer: HTMLElement): boolean
    {
        // NOPE: bail out if all have been copied to the respective containers
        // DONE: we shouldn’t be called in that case

        // NOTE: this should naturally skip those already copied to a respective container
        //       because in that case they would lose this attribute
        let footnotes: NodeListOf<Element> = pageContainer.querySelectorAll('[data-footnotes-container]');
        let copied = 0;

        for (const footnote_ of footnotes as any) {
            const footnote: HTMLAnchorElement = footnote_;

            const containerId = '#footnotes_container_' + footnote.dataset.footnotesContainer;
            const footnotesContainer = document.querySelector(containerId) as HTMLDivElement;

            if (!footnotesContainer) {
                // console.log({page, pageContainer}, 'Skipping', footnote.id, 'as its footnotes container is not loaded yet.');
                continue;
            }

            this._placeFootnote(footnote, footnotesContainer, page);

            // console.log(footnote, footnotesContainer);
            copied++;

            // DONE: remove the attribute when copied to the container
            delete footnote.dataset.footnotesContainer;
        }

        // NOPE: if all (of the rest) have been copied, set a flag/class on the page
        // DONE: actually just return true if so, and false if not
        return copied == footnotes.length;
    }

    private _placeFootnote(footnote: HTMLAnchorElement, footnotesContainer: HTMLDivElement, footnoteSourcePage: BookPage)
    {
        const n = footnote.id.slice(5); // remove the 'note-' prefix

        const apparatusType = /^[a-z]+$/.test(n) ? 'corrections' : 'other-notes';
        const apparatusContainer = footnotesContainer.querySelector(`div.${apparatusType}`) as HTMLDivElement;

        const footnoteDiv = document.createElement('div');
        this._orderNote(footnoteDiv, apparatusContainer, footnoteSourcePage);

        footnoteDiv.className = 'itj-note';
        footnoteDiv.id = 'footnote-' + n;
        footnoteDiv.innerHTML = `<a class="note-ref" href="#note-${n}">${n}</a> `;

        // DONE: the last two footnotes in AsenM (a correction and a regular note)
        //       have an identical text but the regular note should have its own
        // DONE: not all “freehand” footnotes are wrapped in <app> so we should
        //       rather resort to the same selector as before, i.e. the template
        //       is right next to the note
        // NOT universal (yet/ever): footnote.parentElement.querySelector('template')
        const footnoteContentCopy = footnote.nextElementSibling.cloneNode(true) as HTMLTemplateElement;
        footnoteDiv.append(...(footnoteContentCopy.content.childNodes as any));
    }

    private _orderNote(footnoteDiv: HTMLDivElement, apparatusContainer: HTMLDivElement, footnoteSourcePage: BookPage)
    {
        // DONE: how to ensure a stable order of footnotes, given that
        //       (footnotes from) some (pages) are loaded in a random order
        //       and thus may be copied before those from previous pages?
        // NOPE: do we need explicit ordering to be given in/by the input?
        // DONE: perhaps just wrap the collected footnotes in divs per the
        //       source page and keep these sorted by their numeric ID…

        let perPageContainer = apparatusContainer.querySelector(`div[data-page-id="${footnoteSourcePage.pageId}"]`) as HTMLDivElement;

        if (!perPageContainer) {
            perPageContainer = document.createElement('div');
            perPageContainer.dataset.pageId = footnoteSourcePage.pageId.toString();

            const perPageContainers = apparatusContainer.querySelectorAll('[data-page-id]') as NodeListOf<HTMLDivElement>;

            let pos = 0;

            for (; pos < perPageContainers.length; pos++) {
                const pageId = parseInt(perPageContainers[pos].dataset.pageId);
                // console.log(pageId, footnoteSourcePage.pageId);

                if (footnoteSourcePage.pageId < pageId)
                    break;
            }

            // DONE: insert at the correct position
            if (pos == perPageContainers.length)
                apparatusContainer.appendChild(perPageContainer);

            else // https://stackoverflow.com/questions/5882768/how-to-append-a-childnode-to-a-specific-position
                apparatusContainer.insertBefore(perPageContainer, apparatusContainer.children[pos]);
        }

        perPageContainer.appendChild(footnoteDiv);
    }
}


class ImagePanel extends ContentViewPanel {
    protected makeBody(rootReference: Panel, window: Window): HTMLElement {
        var imageContainerDiv: HTMLDivElement = window.document.createElement("div");
        imageContainerDiv.classList.add("reader-image-container");
        return imageContainerDiv;
    }

    public onMoveToPage(pageIndex: number, scrollTo: boolean) {
        if (pageIndex === this.parentReader.currentPageIndex &&
            !$(this.innerContent).is(":empty")
        ) {
            return;
        }
        var pageInfo = this.parentReader.bookHeader.pages[pageIndex];
        $(this.innerContent).empty();

        var image: HTMLImageElement = document.createElement("img");
        image.classList.add("reader-image");
        image.src = getBaseUrl() + "Reader/GetBookImage?snapshotId=" + this.parentReader.versionId + "&pageId=" + pageInfo.pageId;

        var imageLink: HTMLAnchorElement = document.createElement("a");
        imageLink.classList.add("no-click-href");
        imageLink.href = image.src;
        imageLink.onclick = (event: MouseEvent) => {
            return event.ctrlKey;
        };

        imageLink.appendChild(image);
        this.innerContent.appendChild(imageLink);

        var zoomOnClick = false;

        var $innerContent = $(this.innerContent);
        var img = new Image();
        img.onload = () => {

            if (zoomOnClick) {
                $innerContent.zoom({on: "click"});
            } else {
                image.setAttribute("data-image-src", image.src);
                new ImageZoom(image, $(this.innerContent));
                //wheelzoom(image);

                var lastWidth = $innerContent.width();
                var lastHeight = $innerContent.height();
                $(window as any).resize(() => {
                    var newWidth = $innerContent.width();
                    var newHeight = $innerContent.height();

                    if (lastWidth !== newWidth || lastHeight !== newHeight) {
                        image.src = image.getAttribute("data-image-src");

                        new ImageZoom(image, $(this.innerContent));


                        lastWidth = newWidth;
                        lastHeight = newHeight;
                    }
                });

            }
        };
        img.onerror = () => {
            var alert = new AlertComponentBuilder(AlertType.Info);
            alert.addContent(localization.translate("no-image", "BookReader").value);
            $innerContent.html(alert.buildElement());
        };
        img.src = getBaseUrl() + "Reader/GetBookImage?snapshotId=" + this.parentReader.versionId + "&pageId=" + pageInfo.pageId;

    }
}

class AudioPanel extends ContentViewPanel {
    private trackId: number;
    private numberOfTracks: number;
    private currentTrack: HTMLAudioElement;
    private currentTrackDuration: number;

    protected makeBody(rootReference: Panel, window: Window): HTMLElement {
        var audioContainerDiv: HTMLDivElement = document.createElement("div");
        $(audioContainerDiv).addClass("reader-audio-container");
        this.showLoading(audioContainerDiv);

        var trackName = document.createElement("h3");
        $(trackName).addClass("track-name");
        audioContainerDiv.appendChild(trackName);
        var trackSelect = document.createElement("select");
        trackSelect.id = "track-select";
        var book: JQueryXHR = this.sc.getAudioBook(this.parentReader.bookId);
        book.done((response: { audioBook: IAudioBookSearchResultContract }) => {
            this.numberOfTracks = response.audioBook.Tracks.length;
            for (var track of response.audioBook.Tracks) {
                var trackOption = document.createElement("option");
                $(trackOption).prop("value", track.Position - 1);
                $(trackOption).text(track.Name);
                $(trackSelect).append(trackOption);
            }
            for (var recording of response.audioBook.FullBookRecordings) {
                var download = document.createElement("a");
                $(download).addClass("audio-download-href");
                download.href = this.sc.getTrackDownloadUrl(recording.Id, recording.AudioType);
                $(download).html(recording.AudioType);
                $(".full-book").append(download);
            }

            this.trackId = 0;
            this.reloadTrack();
            this.clearLoading();
        });
        book.fail(() => {
            $(".reader-audio-container").empty();
            $(".reader-audio-container").append(localization.translate("FailedToLoadAudioBook", "BookReader").value);
            $(".reader-audio-container").removeClass("loading");
        });

        trackSelect.addEventListener("change", () => {
            this.trackId = Number($(trackSelect).val());
            this.reloadTrack();
        });

        audioContainerDiv.appendChild(trackSelect);

        var audioTextDiv = document.createElement("div");
        $(audioTextDiv).addClass("audio-text");
        audioContainerDiv.appendChild(audioTextDiv);

        var audioPlayerContainer = document.createElement("div");
        $(audioPlayerContainer).addClass("audio-player-container");
        audioContainerDiv.appendChild(audioPlayerContainer);

        var audioDownloadDiv = document.createElement("div");
        $(audioDownloadDiv).addClass("audio-download");
        var downloadBookDiv = document.createElement("div");
        $(downloadBookDiv).addClass("full-book");
        $(downloadBookDiv).append(localization.translate("DownloadAudiobook", "BookReader").value);
        audioDownloadDiv.appendChild(downloadBookDiv);
        var downloadTrackDiv = document.createElement("div");
        $(downloadTrackDiv).addClass("track");
        audioDownloadDiv.appendChild(downloadTrackDiv);
        audioContainerDiv.appendChild(audioDownloadDiv);

        return audioContainerDiv;
    }

    private reloadTrack(autoplay: boolean = false) {
        if (this.currentTrack) {
            this.currentTrack.pause();
        }

        this.showLoading();
        var getTrack: JQueryXHR = this.sc.getTrack(this.parentReader.bookId, this.trackId);
        getTrack.done((response: { track: ITrackWithRecordingContract }) => {
            $(".track-name").html(response.track.Name);
            $("#track-select").val(this.trackId);
            $(".audio-text").html(response.track.Text);
            $(".track").html(`${localization.translate("DownloadChapter", "BookReader").value}:`);
            for (var recording of response.track.Recordings) {
                var download = document.createElement("a");
                $(download).addClass("audio-download-href");
                download.href = this.sc.getTrackDownloadUrl(recording.Id, recording.AudioType);
                $(download).html(recording.AudioType);
                $(".track").append(download);
            }
            this.buildAudioPlayer(response.track, autoplay);
            this.clearLoading();

        });
        getTrack.fail(() => {
            $(".reader-audio-container").empty();
            $(".reader-audio-container").append(localization.translate("FailedToLoadTrack", "BookReader").value);
        });
    }

    private buildAudioPlayer(track: ITrackWithRecordingContract, autoplay: boolean) {
        this.currentTrack = new Audio();
        if (autoplay) {
            $(this.currentTrack).on("canplay", () => {
                this.currentTrack.play();
            })

        }
        this.currentTrackDuration = this.parseStringTimeToSeconds(track.Recordings[0].Duration);
        for (var recording of track.Recordings) {

            var source = document.createElement("source");
            source.src = this.sc.getTrackDownloadUrl(recording.Id, recording.AudioType);
            source.type = recording.MimeType;
            this.currentTrack.appendChild(source);
        }

        var audioContainer = $(".audio-player-container");

        var audioControl = document.createElement("div");
        $(audioControl).addClass("buttons btn-group control-buttons");
        var buttonBack = document.createElement("button");
        $(buttonBack).addClass("glyphicon btn glyphicon-step-backward");
        buttonBack.addEventListener("click", () => {
            if (this.trackId > 0) {
                this.trackId--;
                this.reloadTrack(true);
            }
        });
        audioControl.appendChild(buttonBack);

        var buttonPlay = document.createElement("button");
        $(buttonPlay).addClass(`glyphicon btn ${autoplay ? "glyphicon-pause" : "glyphicon-play"}`);
        buttonPlay.addEventListener("click", () => {
            if (this.currentTrack.paused) {
                $(buttonPlay)
                    .removeClass("glyphicon-play")
                    .addClass("glyphicon-pause");
                this.currentTrack.play();
            } else {
                $(buttonPlay)
                    .removeClass("glyphicon-pause")
                    .addClass("glyphicon-play");
                this.currentTrack.pause();
            }
        });
        audioControl.appendChild(buttonPlay);


        var buttonForward = document.createElement("button");
        $(buttonForward).addClass("glyphicon btn glyphicon-step-forward");
        buttonForward.addEventListener("click", () => {
            if (this.trackId < this.numberOfTracks - 1) {
                this.trackId++;
                this.reloadTrack(true);
            }
        });
        audioControl.appendChild(buttonForward);
        audioContainer.html(audioControl);

        var audioProgress = document.createElement("div");

        var timer = document.createElement("div");
        var currentTimeContainer = document.createElement("span");
        $(this.currentTrack).on("timeupdate", () => {
            currentTimeContainer.innerText = this.getFormattedTime(this.currentTrack.currentTime, this.currentTrackDuration);
        });

        timer.append(currentTimeContainer);
        $(this.currentTrack).on("loadedmetadata", () => {
            currentTimeContainer.innerText = this.getFormattedTime(this.currentTrack.currentTime, this.currentTrackDuration);
            timer.append(` / ${this.getFormattedTime(this.currentTrackDuration, this.currentTrackDuration)}`);
        });
        audioContainer.append(timer);

        var progressBar = document.createElement("div");
        $(progressBar).addClass("full-progressbar");

        var currentProgressEl = document.createElement("div");
        $(currentProgressEl)
            .addClass("current-progress");
        $(this.currentTrack).on("timeupdate loadedmetadata", () => {
            $(currentProgressEl).css("width", this.calculatePercentageProgress(this.currentTrack));
        });

        $(this.currentTrack).on("ended", () => {
            $(buttonPlay)
                .removeClass("glyphicon-pause")
                .addClass("glyphicon-play");
        });

        progressBar.append(currentProgressEl);
        audioContainer.append(progressBar);

    }

    private parseStringTimeToSeconds(time: string): number {
        var splittedTime = time.split(":");
        var seconds = 0;
        for (var i = splittedTime.length - 1; i >= 0; i--) {
            seconds += parseInt(splittedTime[i]) * Math.pow(60, (splittedTime.length - 1) - i);
        }
        return seconds;
    }

    private getFormattedTime(timeInSeconds: number, audioLength: number): string {

        var hours = Math.floor(timeInSeconds / 3600);
        timeInSeconds -= hours * 3600;
        var hoursString: string;
        if (Math.floor(audioLength / 3600) !== 0) {
            if (hours < 10) {
                hoursString = `0${hours}`;
            } else {
                hoursString = `${hours}`;
            }
        }
        var minutes = Math.floor(timeInSeconds / 60);
        timeInSeconds -= minutes * 60;
        var minutesString: string;
        if (Math.floor(audioLength / 60) !== 0) {
            if (minutes < 10) {
                minutesString = `0${minutes}`;
            } else {
                minutesString = `${minutes}`;
            }
        }

        var secondsString: string;
        if (timeInSeconds < 10) {
            secondsString = `0${Math.floor(timeInSeconds)}`;
        } else {
            secondsString = `${Math.floor(timeInSeconds)}`;
        }

        return `${(hoursString !== undefined ? `${hoursString}:` : "")}${(minutesString !== undefined ? `${minutesString}:` : "")}${secondsString}`
    }

    private calculatePercentageProgress(audio: HTMLAudioElement): string {
        return `${audio.currentTime / audio.duration * 100}%`;
    }

    private showLoading(containerDiv?: HTMLElement) {
        if (containerDiv == null) {
            containerDiv = this.innerContent;
        }
        var loader = lv.create(null, "lv-circles lv-mid md");

        var loadingContainer = document.createElement("div");
        $(loadingContainer)
            .addClass("loading-audio")
            .append(loader.getElement());

        $(containerDiv)
            .append(loadingContainer);
    }

    private clearLoading() {
        $(this.innerContent)
            .find(".loading-audio").remove();
    }
}

export {
    AudioPanel,
    BookmarksPanel,
    ContentPanel,
    ContentViewPanel,
    ImagePanel,
    Panel,
    SearchResultPanel,
    TermsPanel,
    TermsResultPanel,
    TermsSearchPanel,
    TextPanel,
    ToolPanel,
};
